import { ArrowRight, Check, Users, MonitorPlay } from "lucide-react";

export default function Modalities({ onCtaClick }) {
  return (
    <section
      id="modalidades"
      data-testid="modalities-section"
      className="py-20 lg:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        {/* Section header */}
        <div className="max-w-2xl mb-14">
          <p className="text-sm uppercase tracking-[0.2em] text-[#c77dff] font-semibold mb-4">
            Modalidades de estudio
          </p>
          <h2
            data-testid="modalities-title"
            className="text-2xl md:text-3xl lg:text-4xl font-medium tracking-tight text-white mb-4"
          >
            Elige cómo quieres aprender
          </h2>
          <p className="text-base text-[#a1a1aa] leading-relaxed">
            Dos formas de avanzar en tus ramos: una personalizada y otra
            flexible. Combínalas según lo que necesites.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-5 lg:gap-6">
          {/* Clases Particulares — takes 3/5 */}
          <div
            data-testid="modality-clases-particulares"
            className="lg:col-span-3 p-8 lg:p-10 rounded-2xl bg-[#242429]/60 border border-[#9d4edd]/20 relative overflow-hidden"
          >
            <div className="relative">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-3 rounded-xl bg-[#9d4edd]/10 text-[#c77dff]">
                  <Users size={22} />
                </div>
                <div>
                  <span className="text-xs uppercase tracking-wider text-[#9d4edd] font-semibold">
                    Servicio principal
                  </span>
                  <h3 className="text-xl lg:text-2xl font-medium text-white">
                    Clases Particulares
                  </h3>
                </div>
              </div>

              <p className="text-[#a1a1aa] leading-relaxed mb-6 max-w-lg">
                Sesiones personalizadas enfocadas en tus dudas específicas,
                tu ritmo y los contenidos de tu universidad. Material de
                apoyo incluido.
              </p>

              <ul className="space-y-3 mb-8">
                {[
                  "Sesiones 1 a 1 con tutor especializado",
                  "Material y recursos visuales de cada sesión",
                  "Flexibilidad de horarios",
                  "Enfoque directo en tus evaluaciones",
                  "Seguimiento continuo de tu avance",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <Check
                      size={16}
                      className="text-[#9d4edd] mt-0.5 flex-shrink-0"
                    />
                    <span className="text-sm text-[#a1a1aa]">{item}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={onCtaClick}
                data-testid="modality-cta-clases"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-[#9d4edd] text-white font-medium text-sm hover:bg-[#7b2cbf] transition-colors duration-200"
              >
                Solicitar clases particulares
                <ArrowRight size={16} />
              </button>
            </div>
          </div>

          {/* Cursos Asincrónicos — takes 2/5 */}
          <div
            data-testid="modality-cursos-asincronicos"
            className="lg:col-span-2 p-8 lg:p-10 rounded-2xl bg-[#242429]/40 border border-white/5"
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="p-3 rounded-xl bg-white/[0.04] text-[#a1a1aa]">
                <MonitorPlay size={22} />
              </div>
              <div>
                <span className="text-xs uppercase tracking-wider text-[#71717a] font-semibold">
                  Complementario
                </span>
                <h3 className="text-xl font-medium text-white">
                  Cursos Asincrónicos
                </h3>
              </div>
            </div>

            <p className="text-[#a1a1aa] leading-relaxed mb-6">
              Contenido estructurado que puedes estudiar a tu ritmo. Ideal
              para complementar tus clases o repasar temas completos por tu
              cuenta.
            </p>

            <ul className="space-y-3 mb-8">
              {[
                "Contenido organizado por módulos",
                "Recursos visuales estilo Manim",
                "Estudia cuando quieras",
                "Complemento ideal a las clases",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <Check
                    size={16}
                    className="text-[#71717a] mt-0.5 flex-shrink-0"
                  />
                  <span className="text-sm text-[#71717a]">{item}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={onCtaClick}
              data-testid="modality-cta-cursos"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-white/10 text-white font-medium text-sm hover:bg-white/5 transition-colors duration-200"
            >
              Explorar cursos
              <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
